import axios from 'axios'
import api from './api'

const paymentService = {
  getPayments: (filters: any) => api.get('/pagos', { params: filters }),
  getPaymentById: (id: number) => api.get(`/pagos/${id}`),
  getPaymentsByContract: (contractId: number) => api.get(`/pagos/contrato/${contractId}`),
  recordPayment: (id: number, data: { payment_date: string; payment_method: string; notes?: string }) =>
    api.put(`/pagos/${id}/registrar`, data),
  updatePaymentStatus: (id: number, status: string) => api.put(`/pagos/${id}/estado`, { status }),
  modifyPaymentAmount: (id: number, amount: number) => api.put(`/pagos/${id}/modificar-monto`, { amount }),
  getOverduePayments: () => api.get('/pagos/atrasados'),
  createCustomPayment: (data: any) => api.post('/pagos/custom', data),
  downloadReceipt: async (id: number) => {
    // Use axios directly to bypass the interceptor that extracts .data
    const baseURL = (api.defaults as any).baseURL || 'http://localhost/backend';
    const response = await axios.get(`${baseURL}/pagos/${id}/recibo`, {
      responseType: 'blob',
      withCredentials: true
    });
    return response.data;
  },
  updatePayment: (id: number, data: { fecha_pago?: string; monto?: number; estado?: string; moneda?: string; dia_pago?: number }) =>
    api.put(`/pagos/${id}`, data),
  bulkModifyFuturePayments: (id: number, data: { monto?: number; dia_pago?: number; moneda?: string; fecha_desde?: string; fecha_hasta?: string }) =>
    api.post(`/pagos/${id}/bulk-modify`, data),
  recordPartialPayment: (id: number, data: { amount: number; metodo_pago?: string; payment_method?: string }) =>
    api.post(`/pagos/${id}/partial`, data),
  getRecibosByPayment: (id: number) => api.get(`/pagos/${id}/recibos`),
}

export default paymentService


